import Enumerable from "linq";
import { RecipientSubTypeEnum } from "../../../common/enums/RecipientSubTypeEnum";
import { RecipientTypeEnum } from "../../../common/enums/RecipientTypeEnum";
import { countries, parsePhoneParts } from "../../recipient-edit-dialog/RecipientEditDialogUtils";
import { RecipientEditDialogFormValuesType } from "../../recipient-edit-dialog/RecipientEditDialog";
import { IFormRecipient } from "../../form-recipient-list/FormRecipientListUtils";
import { IRecipientEditDTO } from "../../../services/recipient-data-service/Models";


export type RecipientsEditorDialogFormValues = {
    recipients: RecipientEditDialogFormValuesType[];
}

export const defaultFormValues: RecipientsEditorDialogFormValues = {
    recipients: []
};

export type RecipientsEditDialogInitValues = {
    recipients: IFormRecipient[],
    organizationID: number
};

export type RecipientsEditDialogReturnValues = {

    recipients: IRecipientEditDTO[],
    organizationID: number

};


export function mapToForm(model: RecipientsEditDialogInitValues): RecipientsEditorDialogFormValues {

    const formValues: RecipientsEditorDialogFormValues  = {
        recipients: []
    };

    model.recipients.forEach(o => {


        if (o.recipientType === RecipientTypeEnum.Email) {
            formValues.recipients.push({
                id: o.id,
                type: o.recipientType,
                subType: RecipientSubTypeEnum.None,
                emailAddress: o.to,
                countryCode: "",
                phoneNumber: "",
                cloneRecipientUsage: false,
                cloneRecipientID: -1,
                linkToRecipientUser: false,
                linkedRecipientUserID: -1,
                userFirstName: '',
                userLastName: ''
            });
        } else {
    
            const { phoneNumber, phonePrefix } = parsePhoneParts(o.to, o.recipientType);

            let countryCode: string = "";
   
            const country = Enumerable
                .from(countries)
                .firstOrDefault(c => c.telephonePrefix === phonePrefix);

            if (country) {
                countryCode = country.telephonePrefix;
            }
    
            formValues.recipients.push({
                id: o.id,
                type: o.recipientType,
                subType: o.recipientSubType ?? RecipientSubTypeEnum.Cell,
                emailAddress: "",
                countryCode: countryCode,
                phoneNumber: phoneNumber,
                cloneRecipientUsage: false,
                cloneRecipientID: -1,
                linkToRecipientUser: false,
                linkedRecipientUserID: -1,
                userFirstName: '',
                userLastName: ''
    
            });
        }    

    });

    return formValues;
};


export function mapToModel(formValues: RecipientsEditorDialogFormValues): IFormRecipient[] {

    return formValues.recipients.map(o => {

        let recipient: IFormRecipient;

        if (o.type === RecipientTypeEnum.Email) {

            recipient = {
                id: o.id,
                recipientType: o.type,
                recipientSubType: o.subType,
                to: o.emailAddress,
            } as IFormRecipient;
        } else {
            const country = countries.find(c => c.telephonePrefix === o.countryCode);
            const to = `+${country?.telephonePrefix ?? 1} ${o.phoneNumber?.replace(/\D/g, "")}`;
    
            recipient = {

                id: o.id,
                recipientType: o.type,
                recipientSubType: o.subType,
                to: to
            } as IFormRecipient;
                
        }
        return recipient;

    });
}
